
let _3targetElem, _3targetElement1, _3targetElement2, _3waitForElement, _3waitForElement2, _3waitForElement3, _3breedsizes, _3atleastOneSelected = false, _3chosenSize = null;
let _3matchingSizes, _3matchingResults, _3chosenByArrow, _3downEventListening;

let _3abSection = document.querySelector('.ab-featured-product-section-3');
let _3abAtcButton = _3abSection ? _3abSection.querySelector('.ab-atc') : null;
let _3abElement = _3abSection ? _3abSection.querySelector('#size-finder') : null;
let _3volumeBlock = _3abSection ? _3abSection.querySelector('.volume-discount-block') : null;
_3breedsizes = (_3abSection && _3abSection.querySelector('#NPAjson')) ? JSON.parse(_3abSection.querySelector('#NPAjson').innerHTML) : [];

let _3sizeids = { XS: ["37540578002", "yellow"], S: ["37843250002", "red"], M: ["37843200658", "blue"], L: ["37843255122", "green"], XL: ["37844540818", "purple"], XXL: ["37844543826", "orange"], XXXL: ["37844544466", "navy"] };


// for the A/B Test Section


const _3waitForNewTarget = function () {
    if (!_3abSection) return;
    _3targetElem = _3abSection.querySelector('.npa-2022-tab-content1');

    _3targetElement1 = _3abSection.querySelector('form#product-form-9876434002');
    _3targetElement2 = _3abSection.querySelector('form#product-form-7724315050213');

    _3waitForElement = _3abSection.querySelector('form#product-form-9876434002 .select-size-parent');

    if (!_3targetElem && !_3targetElement1 && !_3targetElement2) {
        // wait for the target element to be present on the page
        setTimeout(waitTarget, 500);
        return;
    }

    // console.log("Loading breed names from assets");
    // Yes or No Tabs Switching Logic
    Array.from(_3abSection.querySelectorAll(".npa-2022-tab")).forEach(tab => {
        tab.addEventListener("click", function () {
            if (tab.dataset.youknow == "yes") {
                // console.log("Tab Yes Clicked");
                _3abSection.querySelector(".npa-2022-tab-content1").classList.remove("npa-2022-block");
                _3abSection.querySelector(".npa-2022-tab-content1").classList.add("npa-2022-hidden");
                _3abSection.querySelector(".npa-2022-tab-content2").classList.remove("npa-2022-hidden");
                _3abSection.querySelector(".npa-2022-tab-content2").classList.add("npa-2022-block");
                _3abSection.querySelectorAll(".npa-2022-tab")[0].classList.remove("active");
                tab.classList.add("active");
            } else if (tab.dataset.youknow == "no") {
                // console.log("Tab No Clicked");
                _3abSection.querySelector(".npa-2022-tab-content1").classList.remove("npa-2022-hidden");
                _3abSection.querySelector(".npa-2022-tab-content1").classList.add("npa-2022-block");
                _3abSection.querySelector(".npa-2022-tab-content2").classList.remove("npa-2022-block");
                _3abSection.querySelector(".npa-2022-tab-content2").classList.add("npa-2022-hidden");
                _3abSection.querySelectorAll(".npa-2022-tab")[1].classList.remove("active");
                tab.classList.add("active");
            }

            if (_3volumeBlock) {
                _3volumeBlock.classList.add('hide');
            }
        }, false);
    });

    //Total matching Results when user starts typing breed name
    _3matchingResults = 0;
    _3matchingSizes = 0;
    _3downEventListening = false;

    //When User starts typing in the Text Field, bring the suggestions 
    _3abSection.querySelector("#npa20221005-textfield").addEventListener("focus", function () {
        _3bringSuggestionBox();
    }, false);

    //When User presses Esc to close the suggestion
    document.addEventListener("keydown", function (event) {
        if (event.key == "Escape") {
            _3closeSuggestionBox();
        }
    }, false);


    //When the user types a value in the search breed text field
    _3abSection.querySelector("#npa20221005-textfield").addEventListener("input", function () {

        //if suggestion drop-down blurred by accident
        if (_3abSection.querySelector("#npa20221005-suggestion").classList.contains("npa20221005-hidden")) {
            _3bringSuggestionBox();
        }

        //Clear out any previous recommendation
        // _3abSection.querySelector("#npa20221005-weight-leadingText").innerHTML = "";
        _3abSection.querySelector("#weight-leadingText").style.display = 'none';
        _3abSection.querySelector(".weight-subtext").style.display = 'none';
        _3abSection.querySelector("#npa20221005-final-leadingText").style.display = 'none';
        _3abSection.querySelector("#suggestion-note").style.display = 'none';
        _3abSection.querySelector("#npa20221005-weight-results").innerHTML = "";
        _3abSection.querySelector("#npa20221005-final-results").innerHTML = "";
        _3abSection.querySelector("#suggestion-note").innerHTML = "";

        if (this.value.length >= 3) {

            _3abSection.querySelector("#npa20221005-textfield").parentNode.classList.remove("npa20221005-tick");
            //Reset the suggestions and count
            _3abSection.querySelector("#npa20221005-suggestion").innerHTML = "";
            _3matchingResults = 0;

            //Loop through all the breed sizes from the array
            _3breedsizes.forEach(breed => {
                // Find if the value typed is present in any of the looped through data
                var _3dogname = breed.name.toLowerCase().trim();
                if (_3dogname.indexOf(this.value.toLowerCase().trim()) !== -1) {
                    // If present add one to the matching results count
                    _3matchingResults++;

                    //create a div with the suggestion and add it to the suggestion drop down
                    let _3option = document.createElement("div");
                    _3option.classList.add("npa20221005-suggestion-option", "npa20221005-p1");
                    _3option.setAttribute("data-breed", breed.name);
                    _3option.setAttribute("data-size1", JSON.stringify(breed.size1));
                    _3option.setAttribute("data-size2", JSON.stringify(breed.size2));
                    _3option.setAttribute("data-size3", JSON.stringify(breed.size3));
                    _3option.setAttribute("data-size4", JSON.stringify(breed.size4));
                    _3option.setAttribute("data-size5", JSON.stringify(breed.size5));
                    _3option.setAttribute("data-size6", JSON.stringify(breed.size6));
                    _3option.setAttribute("data-size7", JSON.stringify(breed.size7));
                    _3option.innerHTML = "<button class='npa20221005-choosable-option'>" + breed.name + "</button>";
                    _3abSection.querySelector("#npa20221005-suggestion").appendChild(_3option);
                }
            });

            //After a delay of 0.2 seconds after adding all the suggestion
            setTimeout(() => {

                //Highlight the first one ready to be selected by Enter
                _3chosenByArrow = 0;
                if (_3matchingResults > 0) {
                    _3highlightOption(_3chosenByArrow);


                    if (!_3downEventListening) {
                        window.addEventListener("keydown", _3addKeyDownEventForHighlight, false);
                        window.addEventListener("keydown", _3addKeyDownEventForEnter, false);
                        _3downEventListening = true;
                    }

                    //Loop through all the suggestions in the drop-down and add click event listener to all the options
                    Array.from(_3abSection.querySelectorAll(".npa20221005-suggestion-option")).forEach(opt => {

                        opt.addEventListener("click", function (ev) {
                            ev.stopImmediatePropagation();
                            _3matchingSizes = 0;
                            _3dogBreedChosen(opt, opt.dataset.breed);
                            window.removeEventListener("keydown", _3addKeyDownEventForHighlight);
                            window.removeEventListener("keydown", _3addKeyDownEventForEnter);
                            _3downEventListening = false;
                        });

                    });

                }

            }, 200);

        }

        // If all the characters are removed from the search box, suggest user to start typing
        if (this.value.length <= 2) {
            _3abSection.querySelector("#npa20221005-suggestion").innerHTML = "<p> Type at least 3 characters to see suggestions </p>";
            window.removeEventListener("keydown", _3addKeyDownEventForHighlight);
            window.removeEventListener("keydown", _3addKeyDownEventForEnter);

            // for the A/B Test Section
            if (_3abAtcButton) {
                _3abAtcButton.classList.add('disabled');
                _3abAtcButton.textContent = "SELECT BREED TO BEGIN";
                _3abAtcButton.setAttribute('varId', '');
            }

            if (_3volumeBlock) {
                _3volumeBlock.classList.add('hide');
            }

            _3downEventListening = false;
        }

        else if (_3matchingResults == 0) {
            // If there are no matching results
            _3abSection.querySelector("#npa20221005-suggestion").innerHTML = "<p> No matches Found. Please try a different term </p>";
            window.removeEventListener("keydown", _3addKeyDownEventForHighlight);
            window.removeEventListener("keydown", _3addKeyDownEventForEnter);
            _3downEventListening = false;
        }

        if (_3volumeBlock) {
            _3volumeBlock.classList.add('hide');
        }
    }, false);

}

function _3dogBreedChosen(suggestionOption, breedName) {

    //when an _3option is clicked, set the clicked _3option's value in the text field
    _3abSection.querySelector("#npa20221005-textfield").value = suggestionOption.dataset.breed;
    _3abSection.querySelector("#npa20221005-textfield").parentNode.classList.add("npa20221005-tick");

    if (_3abSection.querySelector('#breedProperties')) {
        var _3breedValue = _3abSection.querySelector("#npa20221005-textfield").value;

        _3abSection.querySelector('#breedProperties').value = _3breedValue;
    }

    _3abSection.querySelector("#npa20221005-weight-results").innerHTML = "";
    _3abSection.querySelector("#weight-leadingText").style.display = 'block';
    _3abSection.querySelector(".weight-subtext").style.display = 'block';
    // _3abSection.querySelector("#npa20221005-weight-leadingText").innerHTML = "Weight range of your " + (suggestionOption.dataset.breed == "I don't know" ? "dog" : suggestionOption.dataset.breed) + " in pounds (lbs):";

    if (suggestionOption.dataset.size1 != "null") {
        _3matchingSizes++;
        let _3tempObj = JSON.parse(suggestionOption.dataset.size1);
        if (suggestionOption.dataset.size2 == "null") {
            _3npaWeightRanges(suggestionOption.dataset.breed, _3tempObj, true);
        } else {
            _3npaWeightRanges(suggestionOption.dataset.breed, _3tempObj);
        }
    }

    if (suggestionOption.dataset.size2 != "null") {
        _3matchingSizes++;
        let _3tempObj = JSON.parse(suggestionOption.dataset.size2);
        _3npaWeightRanges(suggestionOption.dataset.breed, _3tempObj);
    }
    if (suggestionOption.dataset.size3 != "null") {
        _3matchingSizes++;
        let _3tempObj = JSON.parse(suggestionOption.dataset.size3);
        _3npaWeightRanges(suggestionOption.dataset.breed, _3tempObj);
    }
    if (suggestionOption.dataset.size4 != "null") {
        _3matchingSizes++;
        let _3tempObj = JSON.parse(suggestionOption.dataset.size4);
        _3npaWeightRanges(suggestionOption.dataset.breed, _3tempObj);
    }
    if (suggestionOption.dataset.size5 != "null") {
        _3matchingSizes++;
        let _3tempObj = JSON.parse(suggestionOption.dataset.size5);
        _3npaWeightRanges(suggestionOption.dataset.breed, _3tempObj);
    }
    if (suggestionOption.dataset.size6 != "null") {
        _3matchingSizes++;
        let _3tempObj = JSON.parse(suggestionOption.dataset.size6);
        _3npaWeightRanges(suggestionOption.dataset.breed, _3tempObj);
    }
    if (suggestionOption.dataset.size7 != "null") {
        _3matchingSizes++;
        let _3tempObj = JSON.parse(suggestionOption.dataset.size7);
        _3npaWeightRanges(suggestionOption.dataset.breed, _3tempObj);
    }

    //If more than size is suggested display info about exchange

    // if(_3matchingSizes > 1) {
    //     _3abSection.querySelector("#npa20221005-exchange-info").classList.remove("npa20221005-hidden");
    //     _3abSection.querySelector("#npa20221005-exchange-info").classList.add("npa20221005-block");
    // } else {
    //     _3abSection.querySelector("#npa20221005-exchange-info").classList.remove("npa20221005-block");
    //     _3abSection.querySelector("#npa20221005-exchange-info").classList.add("npa20221005-hidden");
    // }


    //Remove everything else from the suggestion except the clicked _3option
    _3abSection.querySelector("#npa20221005-suggestion").innerHTML = "";
    let _3option = document.createElement("div");
    _3option.classList.add("npa20221005-suggestion-option");
    _3option.innerHTML = "<button type = 'button' class='npa20221005-choosable-option'>" + suggestionOption.dataset.breed + "</button>";
    _3option.addEventListener("click", function () {
        _3closeSuggestionBox();
    });
    _3abSection.querySelector("#npa20221005-suggestion").appendChild(_3option);

    //Close the suggestion drop down as a suggestion has been already clicked
    _3abSection.querySelector("#npa20221005-suggestion").classList.remove("npa20221005-block");
    _3abSection.querySelector("#npa20221005-suggestion").classList.add("npa20221005-hidden");
}

function _3npaWeightRanges(dogbreed, _3tempObj, autoselect = false) {
    let _3tempSizeName = _3tempObj[0];
    let _3tempWeightRange = _3tempObj[1];
    let _3span1 = document.createElement("span");
    _3span1.classList.add("npa20221005-weight-range", "npa20221005-btn", "npa20221005-mb1", "npa20221005-mr1");
    _3span1.setAttribute("data-swatch", _3tempSizeName);
    // _3span1.innerHTML = _3tempSizeName + " (" + _3sizeids[_3tempSizeName][1]+ ")";
    _3span1.innerHTML = _3tempWeightRange;

    if (autoselect) {
        // console.log("Only one weight range");
        _3span1.classList.add("active");

        _3abSection.querySelector('#weightProperties').value = _3span1.textContent;

        _3abSection.querySelector("#suggestion-note").style.display = "block";
        _3abSection.querySelector("#suggestion-note").innerHTML = "We recommend size " + _3tempSizeName + " for your " + (dogbreed == "I don't know" ? 'dog' : dogbreed) + " based on their breed and weight range";


        // for the A/B Test Section
        if (_3abElement) {

            if (_3abAtcButton) {
                let _3cartLink = "/cart/" + _3sizeids[_3tempSizeName][0] + ":1?storefront=true&discount=TRYTODAY";
                // let _3cartLink = "/cart/"+_3sizeids[_3tempSizeName][0]+":1?storefront=true&discount=PRIMETIME";

                if (_3abSection) {
                    _3abAtcButton.setAttribute('href', _3cartLink);
                }
                _3abAtcButton.setAttribute('varId', _3sizeids[_3tempSizeName][0]);
                _3abAtcButton.textContent = "ADD TO CART";
                _3abAtcButton.classList.remove('disabled');
                

                if (_3volumeBlock) {
                    _3volumeBlock.classList.remove('hide');
                    _3updateVolumeCartLinks(_3sizeids[_3tempSizeName][0]);
                }
            }
        }

        let _3span2 = document.createElement("span");
        _3span2.classList.add("npa20221005-recommended-size", "npa20221005-btn", "npa20221005-mb1", "npa20221005-mr1");
        _3span2.innerHTML = _3tempSizeName + " (" + _3sizeids[_3tempSizeName][1] + ")";

        _3span2.addEventListener("click", function () {
            // let _3trgt = "."+(_3tempSizeName.toLowerCase())+"-"+_3sizeids[_3tempSizeName][1]+"-swatch label";
            let _3trgt = "." + (_3tempSizeName.toLowerCase()) + "-" + _3sizeids[_3tempSizeName][1] + "-swatch";
            _3abSection.querySelector(_3trgt).click();

            // console.log('click on');

            // Show exchange info box if the weight and size are selected
            _3abSection.querySelector("#npa20221005-exchange-info").classList.remove("npa20221005-hidden");
            _3abSection.querySelector("#npa20221005-exchange-info").classList.add("npa20221005-block");

            if (_3is_iOS()) {
                let _3click_ev = document.createEvent("MouseEvent");
                _3click_ev.initEvent("click", false /* bubble */, true /* cancelable */);
                _3abSection.querySelector(_3trgt).dispatchEvent(_3click_ev);
            }

            Array.from(_3abSection.querySelectorAll(".npa20221005-recommended-size")).forEach(rc => {
                rc.classList.remove("active");
            });

            _3span2.classList.add("active");
        }, false);

        _3abSection.querySelector("#npa20221005-final-results").innerHTML = "";
        _3abSection.querySelector("#npa20221005-final-results").appendChild(_3span2);

        _3abSection.querySelector("#npa20221005-weight-results").appendChild(_3span1);


        // If size is 1, make it active
        var _3recommendedSize = _3abSection.querySelectorAll(".npa20221005-recommended-size");

        if (_3span2 && _3recommendedSize.length == 1) {
            var _3clickEvent = new Event("click");
            _3span2.dispatchEvent(_3clickEvent);
        }


    } else {
        _3span1.addEventListener("click", function () {

            Array.from(_3abSection.querySelectorAll(".npa20221005-weight-range")).forEach(wr => {
                wr.classList.remove("active");
                _3span1.classList.add("active");

                _3abSection.querySelector("#npa20221005-final-leadingText").style.display = "block";
                _3abSection.querySelector("#suggestion-note").style.display = "block";
                _3abSection.querySelector("#suggestion-note").innerHTML = "We recommend size " + _3tempSizeName + " for your " + (dogbreed == "I don't know" ? 'dog' : dogbreed) + " based on their breed and weight range";

                let _3span2 = document.createElement("span");
                _3span2.classList.add("npa20221005-recommended-size", "npa20221005-btn", "npa20221005-mb1", "npa20221005-mr1");
                _3span2.innerHTML = _3tempSizeName + " (" + _3sizeids[_3tempSizeName][1] + ")";

                console.log("." + (_3tempSizeName.toLowerCase()) + "-" + _3sizeids[_3tempSizeName][1] + "-swatch label", '_3tempSizeName', _3sizeids[_3tempSizeName][0]);

                // for the A/B Test Section
                if (_3abElement) {

                    if (_3abAtcButton) {
                        let _3cartLink = "/cart/" + _3sizeids[_3tempSizeName][0] + ":1?storefront=true&discount=TRYTODAY";
                        // let _3cartLink = "/cart/"+_3sizeids[_3tempSizeName][0]+":1?storefront=true&discount=PRIMETIME";

                        if (_3abSection) {
                            _3abAtcButton.setAttribute('href', _3cartLink);
                        }
                        _3abAtcButton.setAttribute('varId', _3sizeids[_3tempSizeName][0]);
                        _3abAtcButton.textContent = "ADD TO CART";
                        _3abAtcButton.classList.remove('disabled');
                        

                        if (_3volumeBlock) {
                            _3volumeBlock.classList.remove('hide');
                            _3updateVolumeCartLinks(_3sizeids[_3tempSizeName][0]);
                        }
                    }
                }

                _3span2.addEventListener("click", function () {
                    // let _3trgt = "."+(_3tempSizeName.toLowerCase())+"-"+_3sizeids[_3tempSizeName][1]+"-swatch label";
                    let _3trgt = "." + (_3tempSizeName.toLowerCase()) + "-" + _3sizeids[_3tempSizeName][1] + "-swatch";
                    _3abSection.querySelector(_3trgt).click();

                    // console.log('click on');

                    // Show exchange info box if the weight and size are selected
                    _3abSection.querySelector("#npa20221005-exchange-info").classList.remove("npa20221005-hidden");
                    _3abSection.querySelector("#npa20221005-exchange-info").classList.add("npa20221005-block");

                    if (_3is_iOS()) {
                        let _3click_ev = document.createEvent("MouseEvent");
                        _3click_ev.initEvent("click", false /* bubble */, true /* cancelable */);
                        _3abSection.querySelector(_3trgt).dispatchEvent(_3click_ev);
                    }

                    Array.from(_3abSection.querySelectorAll(".npa20221005-recommended-size")).forEach(rc => {
                        rc.classList.remove("active");
                    });

                    _3span2.classList.add("active");
                }, false);

                _3abSection.querySelector("#npa20221005-final-results").innerHTML = "";
                _3abSection.querySelector("#npa20221005-final-results").appendChild(_3span2);


                // If size is 1, make it active
                var _3recommendedSize = _3abSection.querySelectorAll(".npa20221005-recommended-size");

                if (_3span2 && _3recommendedSize.length == 1) {
                    _3span2.click();
                }

            });

        });

        _3abSection.querySelector("#npa20221005-weight-results").appendChild(_3span1);

    }
}

function _3highlightOption(_3chosenByArrow) {
    Array.from(_3abSection.querySelectorAll(".npa20221005-suggestion-option")).forEach(opt => {
        opt.style.backgroundColor = "transparent";
    });

    _3abSection.querySelectorAll(".npa20221005-suggestion-option")[_3chosenByArrow].style.backgroundColor = "rgba(128,128,128,0.3)";
}

function _3bringSuggestionBox() {
    _3abSection.querySelector("#npa20221005-suggestion").classList.remove("npa20221005-hidden");
    _3abSection.querySelector("#npa20221005-suggestion").classList.add("npa20221005-block");
}

function _3addKeyDownEventForHighlight(eve) {
    eve = eve || window.event;
    if (eve.repeat) { return; }
    _3decideWhatToHighlight(eve);
}

function _3addKeyDownEventForEnter(evnt) {
    evnt = evnt || window.event;

    if (evnt.repeat) { return; }
    if (evnt.key == 'Enter') {
        evnt.stopImmediatePropagation();
        evnt.stopPropagation();
        _3abSection.querySelectorAll(".npa20221005-suggestion-option button")[_3chosenByArrow].click();
    }
}

function _3decideWhatToHighlight(eve) {
    if (_3chosenByArrow >= 0) {
        if (eve.which == 40) {
            _3chosenByArrow++;
            if (_3chosenByArrow >= _3matchingResults - 1) {
                _3chosenByArrow = _3matchingResults - 1;
            }
        } else if (eve.which == 38) {
            _3chosenByArrow--;
            if (_3chosenByArrow < 0) {
                _3chosenByArrow = 0;
            }
        }
        // console.log(_3chosenByArrow);
        _3highlightOption(_3chosenByArrow);
        _3downEventListening = true;
    }
}

function _3closeSuggestionBox() {
    _3abSection.querySelector("#npa20221005-suggestion").classList.remove("npa20221005-block");
    _3abSection.querySelector("#npa20221005-suggestion").classList.add("npa20221005-hidden");

    //window.addEventListener("keydown", _3addKeyDownEventForHighlight, false);
}

function _3is_iOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

_3waitForNewTarget();

if (_3abAtcButton) {
    document.addEventListener("DOMContentLoaded", function () {
        _3abSection.querySelectorAll(".npa20221005-textfield").forEach(function (element) {
            element.addEventListener("change", function () {
                _3abSection.querySelector("#breedProperties").value = this.value;
            });
        });

        _3abSection.querySelector("#npa20221005-weight-results").addEventListener("click", function (event) {
            if (event.target.tagName === "SPAN") {
                _3abSection.querySelector("#weightProperties").value = event.target.textContent;
            }
        });

        _3abSection.addEventListener("click", function (event) {
            if (event.target.classList.contains("npa-2022-btn")) {
                let _3sizeData = event.target.getAttribute("data-youknow");
                if (_3sizeData.indexOf("yes") >= 0) {
                    _3abSection.querySelector("#breedProperties").value = "";
                    _3abSection.querySelector("#weightProperties").value = "";
                }
            }
        });
        
    });
}

function _3updateVolumeCartLinks(varId) {
    if (!_3abSection || !_3volumeBlock) return;

    const volumeOptions = _3volumeBlock.querySelectorAll('.volume-option');
    const atcButton = _3abSection.querySelector('.ab-atc');

    volumeOptions.forEach(option => {
        // Remove existing listeners by cloning (simple way to avoid multiple listeners)
        const newOption = option.cloneNode(true);
        option.parentNode.replaceChild(newOption, option);

        newOption.addEventListener('click', function() {
            const qty = this.dataset.qty;
            
            // UI Update
            _3volumeBlock.querySelectorAll('.volume-option').forEach(opt => opt.classList.remove('active'));
            this.classList.add('active');

            // Determine Discount Code
            let discount = "";
            if (qty === "2") {
                discount = "TOEGRIPSVOLUME2";
            } else if (qty === "3") {
                discount = "TOEGRIPSVOLUME3"; 
            }

            // Update ATC Link
            if (atcButton) {
                const discountParam = discount ? `&discount=${discount}` : "";
                const cartLink = `/cart/${varId}:${qty}?storefront=true${discountParam}`;
                atcButton.setAttribute('href', cartLink);
            }
        });

        // Initialize first link for the currently active option
        if (newOption.classList.contains('active')) {
            const qty = newOption.dataset.qty;
            let discount = "";
            if (qty === "2") discount = "TOEGRIPSVOLUME2";
            else if (qty === "3") discount = "TOEGRIPSVOLUME3";

            if (atcButton) {
                const discountParam = discount ? `&discount=${discount}` : "";
                const cartLink = `/cart/${varId}:${qty}?storefront=true${discountParam}`;
                atcButton.setAttribute('href', cartLink);
            }
        }
    });
}